"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _index = require("../../constants/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PAGE_LOADED = _index.eventTypes.PAGE_LOADED;
var webInteractionTypes = _index.eventFieldValues.webInteractionTypes;
var webInteractionDefaults = function webInteractionDefaults(event) {
  var eventType = (0, _get2["default"])(event, 'event');
  if (eventType === PAGE_LOADED) return event;
  var namePath = 'xdm.web.webInteraction.name';
  var name = (0, _get2["default"])(event, namePath);
  if (!name) (0, _set2["default"])(event, namePath, "".concat(eventType, "_webInteraction.name_is_missing"));
  var typePath = 'xdm.web.webInteraction.type';
  var type = (0, _get2["default"])(event, typePath);
  if (!type) (0, _set2["default"])(event, typePath, webInteractionTypes.OTHER);
  var urlPath = 'xdm.web.webInteraction.URL';
  var url = (0, _get2["default"])(event, urlPath);
  if (!url) (0, _set2["default"])(event, urlPath, window.location.href);
  return event;
};
var _default = exports["default"] = webInteractionDefaults;